
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignFireExtinguisher as ObiSignFireExtinguisherElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-fire-extinguisher.js';
 
 
 

 
 export const ObiSignFireExtinguisher = createComponent({
   react: React,
   tagName: 'obi-sign-fire-extinguisher',
   elementClass: ObiSignFireExtinguisherElement,
   events: {
     
   }
  });
 
 